import React, { useState } from "react";
import logo from "../Images/Logos/ND-common-transparent.png";
import { Link, useNavigate } from "react-router-dom";
import { FaPhoneAlt, FaYoutube } from "react-icons/fa";
import { MdOutlineMail } from "react-icons/md";
import { FaFacebookF } from "react-icons/fa";
import { FaInstagram } from "react-icons/fa6";
import { FaWhatsapp } from "react-icons/fa";
import { AboutUsData, OurWorkData } from "../Components/Utils/data";
import { scrollToTop } from "../Components/Utils/data";
import { Drawer, Button } from "antd";
import { MenuOutlined } from "@ant-design/icons";
const Header = () => {
  const navigate = useNavigate();

  const [isWorkDropDown, setIsworkDropDown] = useState(false);
  const [isAboutDropDown, setIsAboutDropDown] = useState(false);
  const [isOpened, setIsOpened] = useState(false);

  const showDrawer = () => {
    setIsOpened(true);
  };
  const onClose = () => {
    setIsOpened(false);
  };

  const handleNavigation = () => {
    navigate("/");
  };

  return (
    <>
      <header className="sticky top-0 z-50 shadow-md bg-lightGray">
        <div className="flex flex-row ps-2 md:ps-0 gap-4 md:gap-6  items-center md:justify-center text-ndlogoBlue font-medium text-sm md:text-base py-2">
          <Link to="tel:+918977918777" target="_blank">
            <p className="flex items-center gap-2">
              <span className="text-base text-white bg-ndlogoBlue cursor-pointer hover:text-white hover:bg-Orange  rounded-full p-1">
                <FaPhoneAlt />
              </span>
              <span className="text-mediumGray">+91 8977918777</span>{" "}
            </p>
          </Link>
          <Link to="mailto:customer@newdirections.org.in">
            <p className="hidden md:flex items-center gap-2 ">
              <span className="text-base text-white bg-ndlogoBlue  cursor-pointer hover:text-white hover:bg-Orange  rounded-full p-1">
                <MdOutlineMail />
              </span>
              <span className="text-mediumGray">
                customer@newdirections.org.in
              </span>
            </p>
          </Link>
          <p className=" flex flex-row justify-center items-center gap-3">
            <span className="text-base text-white bg-ndlogoBlue cursor-pointer hover:text-white hover:bg-Orange  rounded-full p-1">
              <FaFacebookF />
            </span>
            <span className="text-base text-white bg-ndlogoBlue cursor-pointer hover:text-white hover:bg-Orange  rounded-full p-1">
              <FaInstagram />
            </span>
            <span className="text-base text-white bg-ndlogoBlue cursor-pointer hover:text-white hover:bg-Orange  rounded-full p-1">
              <FaWhatsapp />
            </span>
            <Link
              to="#"
              className="text-base text-white bg-ndlogoBlue cursor-pointer hover:text-white hover:bg-Orange  rounded-full p-1"
            >
              <FaYoutube />
            </Link>
          </p>
        </div>
        <div className="flex md:hidden ps-2 md:ps-0  pb-2">
          <Link to="mailto:customer@newdirections.org.in">
            <p className="flex items-center gap-2 ">
              <span className="text-base text-white bg-ndlogoBlue  cursor-pointer hover:text-white hover:bg-Orange  rounded-full p-1">
                <MdOutlineMail />
              </span>
              <span className="text-mediumGray">
                customer@newdirections.org.in
              </span>
            </p>
          </Link>
        </div>

        <div className="flex items-center text-white bg-ndlogoBlue  justify-between px-6 py-3  mx-auto">
          {/* ***************************** Logo ******************************/}
          <div className="cursor-pointer" onClick={handleNavigation}>
            <img
              src={logo}
              alt="Business Logo"
              className="w-44 md:w-40 lg:w-52"
              onClick={scrollToTop}
            />
          </div>
          {/* ***************************** Hamburger ******************************/}

          <Button
            type="text"
            icon={<MenuOutlined />}
            className="md:hidden text-white text-xl"
            onClick={showDrawer}
          />
          {/* ***************************** Drawer ******************************/}

          <Drawer
            placement="right"
            onClose={onClose}
            open={isOpened}
            className="md:hidden"
          >
            <nav className=" flex flex-col gap-4 text-base font-serif text-ndlogoBlue ">
              <Link className="hover:text-Orange" to="/" onClick={onClose}>
                Home
              </Link>
              {/* <Link
                className="hover:text-Orange"
                to="#about"
                onClick={onClose}
              >
                About Us
              </Link> */}
              <div
                className="relative"
                onMouseEnter={() => setIsAboutDropDown(true)}
                onMouseLeave={() => setIsAboutDropDown(false)}
              >
                <div
                  onClick={() => setIsAboutDropDown((prev) => !prev)}
                  className="flex items-center gap-1 font-serif cursor-pointer hover:text-Orange "
                >
                  About Us
                </div>

                <div
                  className={`absolute left-0 top-full pt-4 transition-all duration-300 transform ${
                    isAboutDropDown
                      ? " opacity-100 translate-y-0 pointer-events-auto"
                      : " opacity-0 -translate-y-4 pointer-events-none"
                  }`}
                >
                  <ul className=" bg-white font-serif text-black rounded-md shadow-lg w-60 z-50 py-2">
                    {AboutUsData.map((item, i) => {
                      return (
                        <div key={i}>
                          <Link
                            to={item.link}
                            // onClick={() => setIsAboutDropDown((prev) => !prev)}
                            onClick={onClose}
                          >
                            <li className="px-4 py-2 text-ndlogoBlue hover:text-white  hover:bg-ndlogoBlue transition">
                              {item.title}
                            </li>
                          </Link>
                        </div>
                      );
                    })}
                  </ul>
                </div>
              </div>
              <div
                className="relative"
                onMouseEnter={() => setIsworkDropDown(true)}
                onMouseLeave={() => setIsworkDropDown(false)}
              >
                <div
                  onClick={() => setIsworkDropDown((prev) => !prev)}
                  className="flex font-serif items-center gap-1 cursor-pointer hover:text-Orange "
                >
                  Our Work
                </div>

                <div
                  className={`absolute left-0 top-full pt-4 transition-all duration-300 transform ${
                    isWorkDropDown
                      ? "opacity-100 translate-y-0 pointer-events-auto"
                      : "opacity-0 -translate-y-4 pointer-events-none"
                  }`}
                >
                  <ul className="bg-white text-black font-serif rounded-md shadow-lg w-60 z-50 py-2">
                    {OurWorkData.map((item, i) => (
                      <div key={i}>
                        <Link to={item.link} onClick={onClose}>
                          <li className="px-4 py-2 text-ndlogoBlue hover:text-white hover:bg-ndlogoBlue transition">
                            {item.title}
                          </li>
                        </Link>
                      </div>
                    ))}
                  </ul>
                </div>
              </div>

              <Link
                className="hover:text-Orange"
                to="/Volunteer"
                onClick={onClose}
              >
                Volunteer
              </Link>
              <Link
                className="hover:text-Orange"
                to="/contact-us"
                onClick={onClose}
              >
                Contact Us
              </Link>
              <Link
                className="hover:text-Orange"
                to="/Donate-Now"
                onClick={onClose}
              >
                Donate Now
              </Link>
            </nav>
          </Drawer>
          {/* ***************************** Navigation ***************************** */}
          <nav className="hidden md:flex">
            <ul className="flex items-center gap-6 lg:gap-12 text-sm  lg:text-base font-medium">
              {/* ***************************** About Us ******************************/}
              <li
                onClick={scrollToTop}
                className="hover:text-Orange font-serif transition-all duration-300 hover:scale-105 "
              >
                <Link to="/">Home</Link>
              </li>

              {/* ***************************** About Us ******************************/}

              <li
                className="relative"
                onMouseEnter={() => setIsAboutDropDown(true)}
                onMouseLeave={() => setIsAboutDropDown(false)}
              >
                <div
                  onClick={() => setIsAboutDropDown((prev) => !prev)}
                  className="flex items-center gap-1 font-serif cursor-pointer hover:text-Orange transition duration-200 hover:scale-105 "
                >
                  About Us
                </div>

                <div
                  className={`absolute left-0 top-full pt-4 transition-all duration-300 transform ${
                    isAboutDropDown
                      ? " opacity-100 translate-y-0 pointer-events-auto"
                      : " opacity-0 -translate-y-4 pointer-events-none"
                  }`}
                >
                  <ul className=" bg-white font-serif text-black rounded-md shadow-lg w-60 z-50 py-2">
                    {AboutUsData.map((item, i) => {
                      return (
                        <div key={i}>
                          <Link
                            to={item.link}
                            onClick={() => setIsAboutDropDown((prev) => !prev)}
                          >
                            <li className="px-4 py-2 text-ndlogoBlue hover:text-white  hover:bg-ndlogoBlue transition">
                              {item.title}
                            </li>
                          </Link>
                        </div>
                      );
                    })}
                  </ul>
                </div>
              </li>

              {/* ***************************** Our Work Dropdown ******************************/}
              <li
                className="relative"
                onMouseEnter={() => setIsworkDropDown(true)}
                onMouseLeave={() => setIsworkDropDown(false)}
              >
                <div
                  onClick={() => setIsworkDropDown((prev) => !prev)}
                  className="flex font-serif items-center gap-1 cursor-pointer hover:text-Orange transition duration-200 hover:scale-105"
                >
                  Our Work
                </div>

                <div
                  className={`absolute left-0 top-full pt-4 transition-all duration-300 transform ${
                    isWorkDropDown
                      ? "opacity-100 translate-y-0 pointer-events-auto"
                      : "opacity-0 -translate-y-4 pointer-events-none"
                  }`}
                >
                  <ul className="bg-white text-black font-serif rounded-md shadow-lg w-60 z-50 py-2">
                    {OurWorkData.map((item, i) => (
                      <div key={i}>
                        <Link
                          to={item.link}
                          onClick={() => setIsworkDropDown((prev) => !prev)}
                        >
                          <li className="px-4 py-2 text-ndlogoBlue hover:text-white hover:bg-ndlogoBlue transition">
                            {item.title}
                          </li>
                        </Link>
                      </div>
                    ))}
                  </ul>
                </div>
              </li>

              {/* ***************************** Volunteer ******************************/}

              <li className="hover:text-Orange font-serif transition duration-200 hover:scale-105 ">
                <Link to="/Volunteer">Volunteer</Link>
              </li>
              {/* ***************************** Contact Us ******************************/}

              <li
                onClick={scrollToTop}
                className="hover:text-Orange font-serif transition duration-200 hover:scale-105 "
              >
                <Link to="/contact-us">Contact Us</Link>
              </li>
              <li>
                <Link
                  to="/Donate-Now"
                  className="bg-white font-serif text-ndlogoBlue px-2 py-1 lg:px-4 lg:py-2 rounded-full transition-all duration-300 ease-in-out transform hover:text-white hover:translate-x-1 hover:bg-gradient-to-r from-Orange to-logoOrange bg-[length:200%_100%] animate-slide-bg inline-block"
                >
                  Donate Now
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </header>
    </>
  );
};

export default Header;
